import { AvgAndSd } from '@/models/statistics/stats-boxplot-subtable-data';
import i18n from '@/i18n';
export class StatisticsUtils {
  /**
   * Cohen-d 効果量「コーエンのd」
   * https://bellcurve.jp/statistics/course/12765.html
   * @param data1 AvgAndSd {avg: 平均, sd: 標準偏差, n: データ数}
   * @param data2 AvgAndSd {avg: 平均, sd: 標準偏差, n: データ数}
   */
  public static cohen(data1: AvgAndSd, data2: AvgAndSd): number {
    const n = data1.n + data2.n;

    const s1 = data1.n * data1.sd ** 2;
    const s2 = data2.n * data2.sd ** 2;

    const sc = Math.sqrt((s1 + s2) / n);

    return Math.abs((data1.avg - data2.avg) / sc);
  }

  /**
   * 効果量の目安用文字列
   * @param d 効果量
   */
  public static effectGuide(d: number): string {
    let guide = '';
    if (d >= 1.2) {
      guide = '（' + i18n.t('VERY_LARGE').toString() + '）';
    } else if (d >= 0.8) {
      guide = '（' + i18n.t('LARGE').toString() + '）';
    } else if (d >= 0.5) {
      guide = '（' + i18n.t('MEDIUM').toString() + '）';
    } else if (d >= 0.2) {
      guide = '（' + i18n.t('SMALL').toString() + '）';
    } else {
      guide = '（' + i18n.t('VERY_SMALL').toString() + '）';
    }
    return guide;
  }
}
